import { render, staticRenderFns } from "./notification_record_modal.vue?vue&type=template&id=0142bfa7"
import script from "./notification_record_modal.vue?vue&type=script&lang=js"
export * from "./notification_record_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports